import { dictionary as commonDictionary } from './common.dictionary.js';
import { compose } from '../dictionary.js';
export const dictionary_de = compose(commonDictionary);
